import { render } from "./TgAwsSecureDownload.vue?vue&type=template&id=7c66656c"
import script from "./TgAwsSecureDownload.vue?vue&type=script&lang=js"
export * from "./TgAwsSecureDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__